import React from "react";
import { Header } from "rsuite";

import styled from "styled-components";

// Navigation
import Navigation from "components/Header/Navigation";

const StyledHeader = styled(Header)`
    width: 100%;
    /* background-color: var(--color-bg); */
    border-bottom: 1px solid var(--color-border);
    padding: 0;
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
`;

const StyledHeaderContainer = styled.div`
    max-width: 1400px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 64px;
    padding: 0 2rem;
`;



const Logo = styled.span`
    @keyframes pulse {
        0%, 100% { transform: scale(1); }
        50% { transform: scale(1.05); }
    }

    display: flex;
    flex-direction: row;

    img {
        margin-right: 10px;
        animation: pulse 3s ease-in-out infinite;
    }
`;

const SiteName = styled.span`
    color: #fff;
    font-family: "Lato";
    font-weight: 700;
    font-size: 32px;
    letter-spacing: -1; 
`;


const SiteHeader = () => {
    return (<StyledHeader>
        <StyledHeaderContainer>
            <Logo>
                <img
                    src={`${process.env.PUBLIC_URL}/logo.svg`}
                    alt="Dump Collector Logo"
                    width={40}
                    height={40}
                />
                <SiteName>Dump Collector</SiteName>
            </Logo>
            <Navigation />
        </StyledHeaderContainer>
    </StyledHeader>);
};

export default SiteHeader;